/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import DrawerPwa from '../DrawerPwa';
import DialogBox from '../DialogBox';
const { selectDesktop, handleCountryPopup } = Slices.appSlice;

export default function MultiCountryPopUp({ variant, anchor, open, children }) {
  const isDesktop = useSelector(selectDesktop);
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(handleCountryPopup());
  };
  return (
    <React.Fragment>
      {isDesktop ? (
        <DialogBox isOpen={open} onClose={onClose} hideCloseButton>
          {children}
        </DialogBox>
      ) : (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={open}
          onClose={onClose}
          hideCloseButton
        >
          {children}
        </DrawerPwa>
      )}
    </React.Fragment>
  );
}
